// Use $ instead of $ without replacing global $
(function($) {
    $(document).ready(function() {
        var length = $("header.header.secondary-navigation.library.event-detail").length;
        if (length === 1) {
            $("header.header.secondary-navigation.library.event-detail ~ .video-overlay").remove();
        }
        $(".article-detail .content .img-box a").each(function() {
            var linkval = $(this).attr('data-video');
            var url = linkval;
            linkval = linkval.split('/')[2];
            if (linkval === 'www.facebook.com') {
                var facebookcode = '<div class="fb-video-outer"><div class="fb-video" data-href="' + url + '"  data-show-text="false" allowfullscreen="" webkitallowfullscreen="" mozallowfullscreen="" playsinline="" allow="autoplay"></div><script async defer src="https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v3.2"></script></div>';
                $(this).parent().append(facebookcode);
            }
        });

        $(document).on('click', '.video-active', '.play-video', function(e) {
            e.preventDefault();
            var linkval = $(this).attr('data-video');
            var video_type = $(this).attr('data-type');
            var url = linkval;
            linkval = linkval.split(' ')[0];
            linkval = linkval.split('/')[2];
            if (linkval === 'www.facebook.com') {
                $('.video-overlay .video-container > iframe').css({ 'display': 'none' });
                $(this).parent().find(".fb-video-outer").clone().appendTo(".video-overlay .video-container");
            }
            var autoplay;
            (linkval.indexOf("autoplay=1") > -1) ? autoplay = "": autoplay = "?autoplay=1&mute=1&feature=youtu.be";
            $(".video-overlay").addClass("active");
            $('body').css("overflow", "hidden");
            if ((url.indexOf('youtube') > 0) || (url.indexOf('youtu.be') > 0)) {
                var newUrl = getVideoId(url);
                if ($('.video-overlay .video-container > iframe').length == 0) {
                    $('<iframe src="about:blank" allowfullscreen="" webkitallowfullscreen="" mozallowfullscreen="" playsinline="" allow="autoplay" ></iframe>').appendTo($('.video-overlay .video-container'));
                }
                $('.video-overlay .video-container > iframe').attr("src", "//www.youtube.com/embed/" + newUrl + "?autoplay=1");
            } else if ((url.indexOf('brightcove.net') > 0)) {
                $('.video-overlay .video-container > iframe').attr("src", url + "&autoplay");
            } else if ((url.indexOf('studio.brightcove') > 0) || (video_type == 'brightcove')) {

                var n = url.lastIndexOf('/');
                var video_id = url.substring(n + 1);
                var iframecode = '<video-js id="myPlayerID" data-video-id="' + video_id + '" data-account="6143005691001" data-player="tjJCToaC0" data-embed="default" class="video-js vjs-fluid" controls poster=""></video-js><script src="https://players.brightcove.net/6143005691001/tjJCToaC0_default/index.min.js"></script>';

                $('.video-overlay .video-container ').html(iframecode);
            } else {
                $('.video-overlay .video-container > iframe').attr("src", url + "?autoplay=1");
            }
            $('.video-overlay').css({ 'display': '1', 'visibility': 'visible' });
        });

        $(document).on('click', '.video-overlay .closeVideo', '.video-overlay', function(e) {
            $('.video-overlay').removeClass('active');
            $('.video-overlay').css({ 'display': '0', 'visibility': 'hidden' });
            $('body').css("overflow", "inherit");
            $('.video-overlay iframe').attr("src", "");
            $('.video-overlay .video-container #myPlayerID').remove();
            $('.video-overlay .video-container .fb-video-outer').remove();
        });

        $(document).on('click', '.video-overlay', function(e) {
            $('.video-overlay').removeClass('active');
            $('.video-overlay').css({ 'display': '0', 'visibility': 'hidden' });
            $('body').css("overflow", "inherit");
            $('.video-overlay iframe').attr("src", "");
            $('.video-overlay .video-container .fb-video-outer').remove();
            $('.video-overlay .video-container #myPlayerID').remove();
        });
        $(".video-overlay .video-container").click(function(e) {
            //e.stopPropagation();
        });

        function getVideoId(url) {
            var regExp = /^((?:https?:)?\/\/)?((?:www|m)\.)?((?:youtube\.com|youtu.be))(\/(?:[\w\-]+\?v=|embed\/|v\/)?)([\w\-]+)(\S+)?$/;
            var match = url.match(regExp);
            if (match && match[5].length == 11) {
                return match[5];
            } else {
                return 'error';
            }
        }

    });
})(jQuery);